import { RECENTLY_BOOKED, shouldShowFeature } from '../../../../../util/customization';

export const getCount = (
  physicalLocationRecentBookings: any,
  associatedTelemedLocationRecentBookings: any
) => {
  return (
    parseInt(physicalLocationRecentBookings, 10) +
    parseInt(associatedTelemedLocationRecentBookings, 10)
  );
};
export const shouldRender = (
  physicalLocation: any,
  physicalLocationRecentBookings: any,
  associatedTelemedLocationRecentBookings: any
) => {
  return (
    !shouldShowFeature(RECENTLY_BOOKED, physicalLocation).visible ||
    getCount(physicalLocationRecentBookings, associatedTelemedLocationRecentBookings) < 1
  );
};
